import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {db, algolia_food, algolia_shops} from './main'
import getImageUrl from '@/assets/js/getImageUrl.js'
import axios from 'axios'

Vue.use(Vuex)

const limit = 20 // テスト用
var foodLastObj = undefined
var postLastObj = undefined
// var shopLastObj = undefined

const magazinApiPosts = 'https://us-central1-karaiine-media.cloudfunctions.net/app/api/posts'
// const newsApiPosts = 'https://us-central1-karaiine-media.cloudfunctions.net/app/api/news'

export default new Vuex.Store({
  state: {
    user: {
      uid: '',
      displayName: '',
      imageurl: '',
      isLogin: false
    },
    config: {
      category: [],
      tag: []
    },
    temp: {
      foodData: {},
      images: [],
      id: '', // foodId
      postId: '',
      user: {}
    },
    pageTransition: [],
    tabetai: [],
    food: {
      query: {
        kwd: '',
        category: '',
        tags: [],
        page: 0,
        sort: 'famous'
      },
      isDone: false,
      list: []
    },
    post: {
      query: {},
      isDone: false,
      list: []
    },
    shops: {
      query: {
        kwd: '',
        pref: '',
        tags: [],
        page: 0
      },
      isDone: false,
      list: []
    },
    userInfo: {
      list: [],
      userInfoCount: 0,
      lastChecked: undefined
    },
    magazin: {
      posts: [] 
    },
    news: {
      posts: [] 
    },
    rank: {
      list: []
    }
  },
  mutations: {
    login (state) {
      state.user.isLogin = true
    },
    logout (state) {
      state.user.isLogin = false
      state.user.displayName = ''
      state.user.uid = ''
      state.user.imageurl = ''
      state.user.photoURL = ''
      state.temp.foodData = {},
      state.temp.images = []
      state.temp.id = ''
      state.temp.user = {}
      state.pageTransition = []
      state.tabetai = []
      state.userInfo.list = []
      state.userInfo.lastChecked = undefined
      state.userInfo.userInfoCount = 0
      state.magazin.posts = []
      state.news.posts = []
      state.rank.list = []
    },
    setUid (state, v) {
      state.user.uid = v
    },
    setDisplayName (state, v) {
      state.user.displayName = v
    },
    setImageurl (state, v) {
      state.user.imageurl = getImageUrl.get('profile', state.user.uid, v)
    },
    setCategory (state, list) {
      state.config.category = list
    },
    setTag (state, list) {
      state.config.tag = list
    },
    setTempFoodData (state, v) {
      state.temp.foodData = v
    },
    setTempImages (state, array) {
      state.temp.images = array
    },
    setTempId (state, v) {
      state.temp.id = v
    },
    deleteTempFoodData (state) {
      state.temp.foodData = {}
      state.temp.id = ''
      state.temp.images = []
      state.temp.postId = ''
    },
    setTempPostId (state, v) {
      state.temp.postId = v
    },
    setTempUser (state, obj) {
      state.temp.user = obj
    },
    pushPageTransition (state, v) {
      let max = 20
      // 最大件数の場合、先頭（もっとも古い値を削除）
      if (state.pageTransition.length >= max) state.pageTransition.shift()
      let obj = {
        fullPath: v.fullPath,
        meta: v.meta,
        name: v.name,
        params: v.params,
        path: v.path
      }
      state.pageTransition.push(obj)
    },
    setTabetai (state, array) {
      state.tabetai = array
    },
    initFood (state) {
      state.food.isDone = false
      state.food.list = []
      state.food.query = {
        kwd: '',
        category: '',
        tags: [],
        page: 0,
        sort: 'famous'
      }
      foodLastObj = undefined
    },
    initPost (state) {
      state.post.isDone = false
      state.post.list = []
      state.post.query = {}
      postLastObj = undefined
    },
    initShops (state) {
      state.shops.isDone = false
      state.shops.list = []
      state.shops.query = {
        kwd: '',
        pref: '',
        tags: [],
        page: 0
      }
      // shopLastObj = undefined
    },
    initMagazin (state) {
      state.magazin.posts = []
    },
    initNews (state) {
      state.news.posts = []
    },
    initRank (state) {
      state.rank.list = []
    },
    setShopsQuery (state) {
      state.shops.isDone = false
    },
    setShopsQueryKwd (state, v) {
      state.shops.query.kwd = v
    },
    setShopsQueryPref (state, v) {
      state.shops.query.pref = v
    },
    pushShop (state, shop) {
      if (shop.basic.imageurl === '') {
        shop.basic.displayImage = '/img/noimage.png'
      } else {
        shop.basic.displayImage = shop.basic.imageurl
      }
      state.shops.list.push(shop)
    },
    setFoodQuery (state) {
      state.food.isDone = false
    },
    setFoodQueryKwd (state, v) {
      state.food.query.kwd = v
    },
    setFoodQueryCategory (state, v) {
      state.food.query.category = v
    },
    setFoodQuerySort (state, v) {
      state.food.query.sort = v
    },
    setFoodQueryTags (state, list) {
      state.food.query.tags = list
    },
    sortFoods (state, sort) {
      let sortParam = 'famousScore'
      if (sort === 'hot') sortParam = 'hotScore'
      else if (sort === 'taste') sortParam = 'tasteScore'
      else if (sort === 'new') sortParam = 'releaseDate'
      state.food.list.sort((a, b) => {
        if (a[sortParam] > b[sortParam]) return -1
        if (a[sortParam] < b[sortParam]) return 1
        return 0
      })
    },
    pushFood (state, food) {
      food.imageurls = []
      if (food.images !== undefined && food.images.length > 0) {
        // 大きい画像の設定
        for (let i = 0; i < food.images.length; i++) {
          let path = food.images[i]
          let url = getImageUrl.get('food', food.id, path)
          food.imageurls.push(url)
        }
        // サムネイル画像
        let path = food.images[0]
        let url = getImageUrl.get('food_thumbs', food.id, path)
        food.thumnail = url
        // console.log(food.thumnail)
      } else {
        food.imageurls.push('/img/noimage.png')
      }
      state.food.list.push(food)
    },
    readUserInfo (state, index) {
      state.userInfo.list[index].isRead = true
    }
  },
  getters: {
    getCategoryNameByKey: (state) => (key) => {
      return state.config.category.find(c => c.key === key)
    },
    getTagByValue: (state) => (value) => {
      return state.config.tag.find(c => c.value === value)
    },
    getTabetaiById: (state) => (foodId) => {
      return state.tabetai.find(t => t.id === foodId)
    },
    isLiked: (state) => (postId) => {
      return state.liked.includes(postId)
    },
    getFoodById: (state) => (foodId) => {
      return state.food.list.find(f => f.id === foodId)
    },
    getFoodIndexById: (state) => (foodId) => {
      return state.food.list.findIndex(f => f.id === foodId)
    },
    getPostById: (state) => (postId) => {
      return state.post.list.find(p => p.id === postId)
    },
    getPostIndexById: (state) => (postId) => {
      return state.post.list.findIndex(p => p.id === postId)
    },
    getShopById: (state) => (shopId) => {
      return state.shops.list.find(shop => shop.id === shopId)
    },
    getShopIndexById: (state) => (shopId) => {
      return state.shops.list.findIndex(shop => shop.id === shopId)
    },
    getArticleById: (state) => (id) => {
      return state.magazin.posts.find(p => p.id === id)
    },
    getNewsPostById: (state) => (id) => {
      return state.news.posts.find(p => p.id === id)
    }
  },
  actions: {
    async getCategoryAndTag ({commit}) {
      let response = await db.collection('config').doc('category_tag').get()
      let data = response.data()
      commit('setCategory', data.category)
      commit('setTag', data.tag)
    },
    async getUserInfo ({state}) {
      state.userInfo.list = []
      state.userInfo.lastChecked = undefined
      state.userInfo.userInfoCount = 0
      if (state.user.uid !== '') {
        let response = await db.collection('userInfo').doc(state.user.uid).get()
        if (response.data()) {
          let userInfo = response.data()
          let list = userInfo.list
          let lastChecked = 0
          if (userInfo.lastChecked) {
            lastChecked = userInfo.lastChecked.seconds
          }
          state.userInfo.lastChecked = lastChecked
          list.forEach(l => {
            if (l.timestamp.seconds > lastChecked) {
              l.isRead = false
              state.userInfo.userInfoCount++
            } else {
              l.isRead = true
            }
            state.userInfo.list.push(l)
          })
        }
      }
    },
    async openUserInfo ({state}) {
      let timestamp = state.userInfo.list[0].timestamp
      await db.collection('userInfo').doc(state.user.uid).set({
        lastChecked: timestamp
      }, {merge: true})
      state.userInfo.userInfoCount = 0
    },
    commitTabetai ({state}) {
      db.collection('tabetai').doc(state.user.uid).set({list: state.tabetai}, {merge: true})
    },
    async getTabetai ({state, commit}) {
      if (state.user.uid !== '') {
        let response = await db.collection('tabetai').doc(state.user.uid).get()
        if (response.data()) {
          commit('setTabetai', response.data().list)
        } else {
          commit('setTabetai', [])
        }
      }
    },
    addTabetai ({state, dispatch},  obj) {
      // タベタイリストの先頭に新規タベタイを追加
      let timestamp = new Date()
      obj['timestamp'] = timestamp
      state.tabetai.unshift(obj)
      dispatch('commitTabetai')
    },
    deleteTabetai ({state, dispatch}, obj) {
      let index  = state.tabetai.findIndex(t => t.id === obj.id)
      state.tabetai.splice(index, 1)
      dispatch('commitTabetai')
    },
    async getFoodNext ({state, dispatch}) {
      state.food.isDone = false
      return await dispatch('getFoodByQuery', false)
    },
    async getFoodByQuery({state, commit}, isListClear) {
      // メモ：state.food.queryを更新する処理が必要。その際に、isDoneをfalseにする

      // クエリ実行済の場合はstoreのデータを返す
      if (state.food.isDone) return state.food.list

      if (isListClear) {
        state.food.list = []
        foodLastObj = undefined
        state.food.query.page = 0
      }
      
      if (state.food.query.kwd) {
        // ★キーワードの指定あり => Algoliaを検索
        let params = {}
        // kwd
        params.query = state.food.query.kwd
        params.hitsPerPage = 100

        // tags
        if (state.food.query.tags.length > 0) {
          let tags = []
          state.food.query.tags.forEach(tag => {
            tags.push(tag.value)
          })
          params.tagFilters = tags
        }

        // facets カテゴリ絞込
        if (state.food.query.category) {
          let facets = []
          facets.push('category:' + state.food.query.category)
          params.facetFilters = facets         
        }
        // tags
        if (state.food.query.tags.length > 0) {
          let tags = []
          state.food.query.tags.forEach(tag => {
            tags.push(tag.value)
          })
          params.tagFilters = tags
        }
        // sort
        // if (state.food.query.sort) {
        //   let customRanking = []
        //   if (state.food.query.sort === 'famous') {
        //     customRanking.push('desc(famousScore)')
        //   } else if (state.food.query.sort === 'hot') {
        //     customRanking.push('desc(hotScore)')
        //   } else if (state.food.query.sort === 'taste') {
        //     customRanking.push('desc(tasteScore)')
        //   } else if (state.food.query.sort === 'new') {
        //     customRanking.push('desc(releaseDate)')
        //   } else {
        //     customRanking.push('desc(famousScore)')
        //   }
        //   params.customRanking = customRanking
        // }

        // page
        params.page = state.food.query.page
        state.food.query.page++

        let response = await algolia_food.search(params)
        let foods = response.hits
        foods.forEach(f => {
          f.id = f.objectID
          commit('pushFood', f)
        })
        commit('sortFoods', state.food.query.sort)
      } else {
        // ★キーワードの指定なし => firebaseを検索
        var dbRef = db.collection('food')

        // tags
        if (state.food.query.tags) {
          state.food.query.tags.forEach(tag => {
            let t = 'tags.' + tag.value
            dbRef = dbRef.where(t, '==', true)
          })
        }

        // カテゴリ
        if (state.food.query.category) {
          dbRef = dbRef.where('category', '==', state.food.query.category)
        }

        // ソート
        if (state.food.query.sort === 'famous') {
          dbRef =  dbRef.orderBy('famousScore', 'desc')
        } else if (state.food.query.sort === 'hot') {
          dbRef =  dbRef.orderBy('hotScore', 'desc')
        } else if (state.food.query.sort === 'taste') {
          dbRef =  dbRef.orderBy('tasteScore', 'desc')
        } else if (state.food.query.sort === 'new') {
          dbRef =  dbRef.orderBy('releaseDate', 'desc')
        } else {
          dbRef =  dbRef.orderBy('famousScore', 'desc')
        }

        if (foodLastObj) {
          dbRef = dbRef.startAfter(foodLastObj)
        }
        let response = await dbRef.limit(limit).get()
        
        state.food.isDone = true
        response.forEach((doc) => {
          foodLastObj = doc          
          let food = doc.data()
          food.id = doc.id
          commit('pushFood', food)
        })
      }
      return state.food.list
    },
    async getPostNext ({state, dispatch}) {
      state.post.isDone = false
      return await dispatch('getPostByQuery')
    },
    async getPostByQuery({state}) {
      // メモ：state.food.queryを更新する処理が必要。その際に、isDoneをfalseにする
      if (!state.post.isDone) {
        let dbRef = db.collection('post').orderBy('timestamp', 'desc')
        if (postLastObj) {
          dbRef = dbRef.startAfter(postLastObj)
        }
        
        let response = await dbRef.limit(limit).get()
        state.post.isDone = true
        response.forEach((doc) => {
          postLastObj = doc
          let post = doc.data()
          post.id = doc.id
          state.post.list.push(post)
          let index = state.post.list.length - 1
          state.post.list[index].imageurls = []
          if (state.post.list[index].images !== undefined) {
            state.post.list[index].images.forEach(path => {
              let url = getImageUrl.get('post', state.post.list[index].id, path)
              state.post.list[index].imageurls.push(url)
              state.post.list[index].imageurls.sort(function (a, b) {
                if( a < b ) return -1;
                if( a > b ) return 1;
                return 0;
              })
            })
          }
        })
        return state.post.list
      } else {
        return state.post.list
      }
    },
    async getShopsNext ({state, dispatch}) {
      state.shops.isDone = false
      return await dispatch('getShopsByQuery', false)
    },
    async getShopsByQuery({state, commit}, isListClear) {
      // メモ：state.shops.queryを更新する処理が必要。その際に、isDoneをfalseにする

      // クエリ実行済の場合はstoreのデータを返す
      if (state.shops.isDone) return state.shops.list

      if (isListClear) {
        state.shops.list = []
        state.shops.query.page = 0
        // shopLastObj = undefined
      }
      
      let params = {}
      // kwd
      params.query = state.shops.query.kwd

      // facets カテゴリ絞込
      // params.facetFilters = [ [aaa, bbb], ccc] => (aaa or bbb) and ccc
      if (state.shops.query.pref) {
        let facets = []
        let pref = []
        let str1 = state.shops.query.pref // 東京都
        let str2 = str1.slice(0, -1) // 東京
        pref.push('basic.area.m:' + str1)
        pref.push('basic.area.m:' + str2)
        facets.push(pref)
        params.facetFilters = facets  
      }
      
      // page
      params.page = state.shops.query.page
      // 次の検索用にインクリメント
      state.shops.query.page++
      
      let response = await algolia_shops.search(params)
      let shops = response.hits
      shops.forEach(s => {
        s.id = s.objectID
        commit('pushShop', s)
      })
      return state.shops.list
    },
    addPostComment({state, getters}, postId) {
      if(state.post.list.length===0) return
      let index = getters.getPostIndexById(postId)
      if (state.post.list[index].commentCount) {
        state.post.list[index].commentCount++
      } else {
        state.post.list[index].commentCount = 1
      }
    },
    async getMagazin({state}) {
      if (state.magazin.posts.length === 0) {
        let res = await axios.get(magazinApiPosts)
        state.magazin.posts = res.data
      }
      return state.magazin.posts
    },
    async getNews({state}) {
      if (state.news.posts.length === 0) {
        // let res = await axios.get(newsApiPosts)
        let res = await db.collection('news').where('isOpen', '==', true).orderBy('releaseDate', 'desc').limit(20).get()
        res.forEach(doc => {
          let obj = doc.data()
          obj.id = doc.id
          if (obj.releaseDate) {
            let cols = obj.releaseDate.split(/[-T]/)
            obj.dateStr = Number(cols[1]) + '月' + cols[2] + '日'
          } else {
            obj.dateStr = ''
          }
          state.news.posts.push(obj)  
        })
      }
      return state.news.posts
    },
    async getNewsMore({state, dispatch}) {
      if (state.news.posts.length === 0) {
        return dispatch('getNews')
      } else {
        let lastObj = state.news.posts[state.news.posts.length - 1]
        let lastDate = lastObj.releaseDate
        let res = await db.collection('news').where('isOpen', '==', true).orderBy('releaseDate', 'desc').startAfter(lastDate).limit(20).get()
        res.forEach(doc => {
          let obj = doc.data()
          obj.id = doc.id
          if (obj.releaseDate) {
            let cols = obj.releaseDate.split(/[-T]/)
            obj.dateStr = Number(cols[1]) + '月' + cols[2] + '日'
          } else {
            obj.dateStr = ''
          }
          state.news.posts.push(obj)  
        })
        return state.news.posts
      }
    },
    async getRank({state}) {
      if (state.rank.list.length === 0) {
        let dbRef = db.collection('rank').orderBy('obj.sortParam', 'desc')
        let response = await dbRef.get()
        response.forEach((doc) => {
          let rank = doc.data()
          state.rank.list.push(rank)
        })
      }
      return state.rank.list
    }
  },
  plugins: [createPersistedState()]
})
